import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import { Image, Modal } from 'react-bootstrap';
import { CLOSE_ICON } from '../../constants/assetConstants';
import Button from '../Button/Button';
import { ButtonV2 } from '../ButtonV2/ButtonV2';
import Loader from '../Loader/Loader';
import styles from './InfoDialogUI.module.scss';
import { CloseIcon2 } from '../../assets/icons';
import { useCustomKeyPress } from '../../hooks/useCustomKeyPress';

// export type TProps = {
//   icon: 'info' | 'success' | 'delete' | 'confirmation' | 'error';
//   title: React.ReactNode;
//   buttonText: React.ReactNode;
//   cancelButtonText?: React.ReactNode;
//   contentContainerProps?: any;
//   closeable?: boolean;
//   onClose?: () => void;
//   onButtonClick: () => Promise<any> | void;
//   onCancelClick?: () => void;
// } & Omit<Omit<DialogProps, 'title'>, 'onClose'>;

export const InfoDialogUI = ({
  title,
  content,
  buttonText,
  cancelButtonText,
  onButtonClick,
  okBtnColor,
  onCancelClick,
  cancelBtnColor,
  onClose,
  icon,
  description,
  secondLineDescription,
  maxWidth,
  contentContainerProps,
  closeable = true,
  children,
  contentClassName,
  dialogClassName,
  bodyClassName,
  fitContent,
  hideTitle,
  theme,
  size = 'md',
  preventClose,
  okBtnClassName,
  okButtonProps,
  cancelButtonProps,
  loader,
  btnContainerClass,
  addOrSeparator = false,
  onButtonClick2,
  buttonText2,
  isButton2Cancel,
  designV2 = false,
  designV2Props = {},
  topIcon = null,
  titleStyle = {},
  descriptionStyle = {},
  ...rest
}) => {
  const [loading, setLoading] = useState(false);
  const isV2 = theme === 'v2';
  okBtnColor = isV2 ? 'primary' : 'warning';
  cancelBtnColor = isV2 ? 'dark' : 'secondary';

  const handleButtonClick = async (e) => {
    setLoading(true);
    // TODO: work on this logic
    await onButtonClick?.(e);
    try {
      setLoading(false);
    } catch (e) {
      // it will fail only when component was unmounted, ignore this error
    }
  };
  const handleButtonClick2 = async (e) => {
    setLoading(true);
    // TODO: work on this logic
    await onButtonClick2?.(e);
    try {
      setLoading(false);
    } catch (e) {
      // it will fail only when component was unmounted, ignore this error
    }
  };

  const showCancelButton = Boolean(onCancelClick);
  const showOkButton = Boolean(buttonText && onButtonClick);
  const showOkButton2 = Boolean(buttonText2 && onButtonClick2);
  const handleClose = preventClose ? undefined : onClose;
  const showButtons = showCancelButton || showOkButton;

  useEffect(() => {
    setLoading(false);
  }, [rest.open]);

  useCustomKeyPress({ callback: handleButtonClick, active: rest.open && showOkButton });

  return (
    <Modal
      onHide={handleClose}
      centered
      size={size}
      {...rest}
      backdropClassName={cx(rest.backdropClassName, styles.backdrop, isV2 && styles.v2Backdrop)}
      dialogClassName={cx(
        styles.modal,
        dialogClassName,
        theme && styles[`${theme}Theme`],
        fitContent && styles.fitContent
      )}
      contentClassName={cx(styles.content, contentClassName)}>
      <Modal.Body className={cx(styles.body, bodyClassName, designV2 && styles.designV2)}>
        <Loader position="absolute" loading={loading || loader} backdrop />
        {topIcon && <div className="mb-2">{topIcon}</div>}
        {!hideTitle && (
          <div className={styles.titleContainer}>
            {title && (
              <h2 style={titleStyle} className={styles.title}>
                {title}
              </h2>
            )}
            {closeable && onClose && (
              <button
                className={rest?.closeIconV2 ? styles.closeV2 : styles.close}
                onClick={handleClose}>
                {rest?.closeIconV2 ? <CloseIcon2 /> : <Image src={CLOSE_ICON} />}
              </button>
            )}
            {description && (
              <div style={{ ...titleStyle, ...descriptionStyle }} className={styles.description}>
                {description}
              </div>
            )}
            {secondLineDescription && (
              <div
                style={{ ...titleStyle, ...descriptionStyle }}
                className={styles.description}
                dangerouslySetInnerHTML={{ __html: secondLineDescription }}></div>
            )}
          </div>
        )}
        {content}
        {children}
        {!isV2 && (showCancelButton || showOkButton || showOkButton2) && (
          <div
            className={cx(
              'd-flex gap-3 mt-4',
              btnContainerClass,
              !designV2 && 'justify-content-center'
            )}>
            {showCancelButton && (
              <Button
                color={cancelBtnColor}
                onClick={onCancelClick}
                className={`${designV2 ? '' : 'w-100'} ${designV2Props.cancelBtnClassName}`}
                size="xlg"
                {...cancelButtonProps}>
                {cancelButtonText}
              </Button>
            )}
            {showOkButton && (
              <Button
                variant="secondary"
                color={okBtnColor}
                size="xlg"
                onClick={handleButtonClick}
                className={`${designV2 ? '' : 'w-100'} ${okBtnClassName} ${
                  designV2Props.fillBtnClassName
                }`}
                {...okButtonProps}>
                {buttonText}
              </Button>
            )}
            {addOrSeparator && <span>Or</span>}
            {showOkButton2 && (
              <Button
                variant="secondary"
                color={isButton2Cancel ? cancelBtnColor : okBtnColor}
                size="xlg"
                onClick={handleButtonClick2}
                className={`${designV2 ? '' : 'w-100'} ${
                  isButton2Cancel ? designV2Props.cancelBtnClassName : designV2Props.okBtnClassName
                }`}
                {...okButtonProps}>
                {buttonText2}
              </Button>
            )}
          </div>
        )}
        {isV2 && showButtons && (
          <div className="d-flex justify-content-center gap-2 mt-3">
            {showCancelButton && (
              <ButtonV2
                color={cancelBtnColor}
                onClick={onCancelClick}
                size="sm"
                {...cancelButtonProps}>
                {cancelButtonText}
              </ButtonV2>
            )}
            {showOkButton && (
              <ButtonV2
                variant="secondary"
                color={okBtnColor}
                onClick={handleButtonClick}
                size="sm"
                {...okButtonProps}>
                {buttonText}
              </ButtonV2>
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default InfoDialogUI;
